/** A tag's letters, one space, then its digit-led number: `TE 603`, `XA 7207.I`, `BSL 201A/B`. */
const SPACED_TAG = /^([A-Za-z]{1,5}) (\d{1,5}[A-Z0-9]*(?:[./][A-Z0-9]+)*)$/;

/** The TypeScript copy of the backend's TAG-001 rule: the hyphen spelling of a tag written with a
 *  space between its letters and its number (`te 603` → `TE-603`), or null for any other text.
 *  The cases in the test beside this file and in the backend's TAG-001 tests keep the two equal. */
export function hyphenatedTag(text: string): string | null {
  const match = SPACED_TAG.exec(text.trim());
  return match ? `${match[1].toUpperCase()}-${match[2]}` : null;
}
